import { ValidatorFn, Validators } from '@angular/forms';
import { emailPattern } from '@helpers/custom-validator';

export const fullOrganizationFormFields: Array<{ key: string; validators: ValidatorFn[]; children?: any }> = [
  { key: 'id', validators: [] },
  { key: 'businessIdNumber', validators: [] },
  { key: 'businessName', validators: [] },
  {
    key: 'address',
    validators: [],
    children: [
      { key: 'city', validators: [] },
      { key: 'country', validators: [] },
      { key: 'postalCode', validators: [Validators.maxLength(9)] },
      { key: 'state', validators: [] },
      { key: 'line1', validators: [Validators.maxLength(32)] },
      { key: 'line2', validators: [] },
      { key: 'line3', validators: [] },
    ],
  },
  {
    key: 'contactInformation',
    validators: [],
    children: [
      { key: 'businessPhone', validators: [] },
      { key: 'businessEmail', validators: [Validators.required, Validators.pattern(emailPattern)] },
    ],
  },
  { key: 'logoUri', validators: [] },
  { key: 'identifier', validators: [] },
  { key: 'identifierQualifier', validators: [] },
  { key: 'dateOfBirth', validators: [] },
];
